const GenericMessagePage = (props: { msgText: string, msgFormatting: string }) => {
  return (
    <div className={props.msgFormatting}>
      <p>{props.msgText}</p>
    </div>
  )
}

export default GenericMessagePage
